var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1693 1.58568C12.1693 1.03586 11.7236 0.590136 11.1737 0.590136L2.21383 0.590135C1.664 0.590134 1.21828 1.03586 1.21828 1.58568C1.21828 2.1355 1.664 2.58123 2.21383 2.58123L10.1782 2.58123L10.1782 10.5456C10.1782 11.0954 10.6239 11.5411 11.1737 11.5411C11.7236 11.5411 12.1693 11.0954 12.1693 10.5456L12.1693 1.58568ZM1.92224 12.2451L11.8777 2.28964L10.4698 0.881725L0.514322 10.8372L1.92224 12.2451Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExternalLink);
export default __webpack_public_path__ + "static/media/icon-external-link.f271fbcc0b725e5d871d2739647d8a2b.svg";
export { ForwardRef as ReactComponent };